export default __webpack_public_path__ + "static/media/checked-delta.b0eda8a5.svg";